import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContactFormRoutingModule } from './contact-form-routing.module';
import { ContactFormComponent } from './contact-form.component';
import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { RecaptchaModule } from 'ng-recaptcha-2';
import { ReferralClickIdModule } from '@app/unauthenticated/referral-click-id.module';

@NgModule({
  declarations: [ContactFormComponent],
  imports: [
    CommonModule,
    ContactFormRoutingModule,
    SharedModule,
    TranslateModule,
    RecaptchaModule,
    ReferralClickIdModule,
  ],
})
export class ContactFormModule {}
